import TechnologyHome from "../views/technology/Home/TechnologyHome";
import DevelopmentRequests from "../views/technology/DevelopmentRequests/DevelopmentRequests";
import DevelopmentRequirementForm from "../views/technology/DevelopmentRequests/Form/DevelopmentRequirementForm";
import DevelopmentRequirementDetail from "../views/technology/DevelopmentRequests/Detail/DevelopmentRequirementDetail";
import DigitalBusinessCard from "../views/technology/DigitalBusinessCard/DigitalBusinessCard";
import DigitalBusinessCardAdmin from "../views/technology/DigitalBusinessCardAdmin/DigitalBusinessCardAdmin";
import OutlookSignatures from "../views/technology/OutlookSignatures/OutlookSignatures";
import TechnologyIdentityConfiguration from "../views/technology/IdentityConfiguration/TechnologyIdentityConfiguration";

export const paths = {
    home: '/technology/home',
    developmentRequests: '/technology/development-requests',
    developmentRequestCreate: '/technology/development-requests/new',
    developmentRequestDetail: '/technology/development-requests/:id',
    digitalBusinessCard: '/technology/digital-business-card',
    digitalBusinessCardAdmin: '/technology/digital-business-card-admin',
    outlookSignatures: '/technology/outlook-signatures',
    identityConfiguration: '/technology/identity-configuration'
};

export default (securityManager) => {
    const routes = [];

    routes.push({
        path: paths.home,
        name: "Tecnología TGLE",
        component: TechnologyHome,
        hidden: true
    });

    if (securityManager?.technology.canListDevelopmentRequests()) {
        routes.push({
            name: "Solicitudes de Desarrollo",
            icon: "fa fa-code",
            path: paths.developmentRequests,
            component: DevelopmentRequests
        });
    }

    if (securityManager?.technology.canAccessDigitalBusinessCard()) {
        routes.push({
            name: "Tarjeta Digital",
            icon: "fa fa-address-card",
            path: paths.digitalBusinessCard,
            component: DigitalBusinessCard
        });
    }

    if (securityManager?.technology.canAdminDigitalBusinessCards()) {
        routes.push({
            name: "Administrar Tarjetas",
            icon: "fa fa-id-card-o",
            path: paths.digitalBusinessCardAdmin,
            component: DigitalBusinessCardAdmin
        });
    }

    if (securityManager?.technology.canGenerateOutlookSignatures()) {
        routes.push({
            name: "Firmas Outlook",
            icon: "fa fa-envelope",
            path: paths.outlookSignatures,
            component: OutlookSignatures
        });
    }

    if (securityManager?.technology.canCreateDevelopmentRequests()) {
        routes.push({
            path: paths.developmentRequestCreate,
            name: "Nuevo requerimiento",
            component: DevelopmentRequirementForm,
            hidden: true
        });
    }

    if (securityManager?.technology.canShowDevelopmentRequests()) {
        routes.push({
            path: paths.developmentRequestDetail,
            name: "Detalle del requerimiento",
            component: DevelopmentRequirementDetail,
            hidden: true
        });
    }

    if (securityManager?.technology.canConfigureCorporateIdentity()) {
        routes.push({
            name: "Identidad Corporativa",
            icon: "fa fa-building-o",
            path: paths.identityConfiguration,
            component: TechnologyIdentityConfiguration
        });
    }

    return routes;
};
